/**
 * Language Switcher Utility
 * Handles language switching for the main Django app
 */
class LanguageSwitcher {
  constructor() {
    this.currentLanguage = this.getCurrentLanguage();
  }

  /**
   * Get current language from various sources
   */
  getCurrentLanguage() {
    // Check cookie first
    const cookieMatch = document.cookie.match(/django_language=([^;]+)/);
    if (cookieMatch && ['en', 'fr'].includes(cookieMatch[1])) {
      return cookieMatch[1];
    }

    // Check localStorage
    const stored = localStorage.getItem('language');
    if (stored && ['en', 'fr'].includes(stored)) {
      return stored;
    }

    // Check HTML lang attribute
    const htmlLang = document.documentElement.lang;
    if (htmlLang && ['en', 'fr'].includes(htmlLang.split('-')[0])) {
      return htmlLang.split('-')[0];
    }

    return 'en'; // Default fallback
  }

  /**
   * Switch to the opposite language
   */
  toggleLanguage() {
    const newLanguage = this.currentLanguage === 'en' ? 'fr' : 'en';
    this.setLanguage(newLanguage);
  }

  /**
   * Set specific language
   */
  setLanguage(language) {
    if (!['en', 'fr'].includes(language)) {
      return;
    }

    this.currentLanguage = language;

    // Store in localStorage
    localStorage.setItem('language', language);

    // Set Django cookie
    document.cookie = `django_language=${language}; path=/; max-age=31536000`; // 1 year

    // Update UI immediately
    this.updateUI(language);

    // Redirect to trigger Django language change
    this.reloadPage();
  }

  /**
   * Update UI elements immediately
   */
  updateUI(language) {
    // Update the current language display
    const languageDisplay = document.getElementById('current-language');
    if (languageDisplay) {
      languageDisplay.textContent = language.toUpperCase();
    }

    // Update HTML lang attribute
    document.documentElement.lang = language;
  }

  /**
   * Reload the page to apply Django language changes
   */
  reloadPage() {
    // Small delay to ensure cookie is set
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  /**
   * Initialize the language switcher
   */
  ready() {
    // Make toggle function globally available
    window.toggleLanguage = () => this.toggleLanguage();

    // Update UI on load
    this.updateUI(this.currentLanguage);

    // Listen for language changes from other sources (like React apps)
    window.addEventListener('languageChanged', (event) => {
      if (event.detail && event.detail.language) {
        this.currentLanguage = event.detail.language;
        this.updateUI(event.detail.language);
      }
    });
  }
}

export default new LanguageSwitcher();
